import AppointmentsAndPreAdvicesBaseController from './appointments_and_pre_advices_base_controller';

export default class extends AppointmentsAndPreAdvicesBaseController {
  get entityIdKey() {
    return 'appointmentId';
  }

  fetchUrl(id) {
    return `/appointments/${id}/gate_in.json`;
  }

  populateForm(data) {
    // Call the base controller's populateForm function
    super.populateForm(data);

    // Show modal if arrival is outside tolerance
    if (data.arrived_before_start_tolerance || data.arrived_after_end_tolerance) {
      $('#early-or-late-truck-arrival-modal').modal({
        backdrop: 'static',  // Prevents closing when clicking outside
        keyboard: 'false',   // Prevents closing with the escape key
        show: true
      });
    }
  }
}
